const RetroFormLayout = ({ title, children, onSubmit }) => (
  <div style={{
    position: 'relative ',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: '"Press Start 2P", cursive',
    color: '#00ff00',
    padding: '20px',
  }}>
    <div style={{
      backgroundColor: '#1a1a1a',
      border: '2px solid #00ff00',
      borderRadius: '10px',
      padding: '30px',
      width: '100%',
      maxWidth: '500px',
    }}>
      <h2 style={{ textAlign: 'center', marginTop: 0 }}>{title}</h2>

      <form 
      onSubmit={onSubmit} 
      style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {children}
      </form>
    </div>
  </div>
);
export default RetroFormLayout